module.exports = __webpack_public_path__ + "static/media/3_Chippy.66732f47.png";